import { useTranslation } from 'react-i18next';
import { Place, PublicLead } from "shared/topchef.types";


const locHallBackOfficeRecipient = 'contact@lochall.fr';


export interface FollowLeadButtonProps {
  loggedInPlace: Place,
  lead: PublicLead
  followLead: () => void;
}


const FollowLeadButton = (props: FollowLeadButtonProps) => {

  const { t } = useTranslation();

  const followLeadAndDisplayEmail = async () => {

    props.followLead();

    const subject = `${props.loggedInPlace.name} se positionne sur un brief`;
    const body = `Bonjour,\n\n\nJe souhaite me positionner sur le brief avec l'identifiant '${props.lead.id}'.\n\n\n Cordialement, \n\n\n${props.loggedInPlace.name}`;
    const mailtoLink = `mailto:${locHallBackOfficeRecipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink, "_blank");
  }


  const followedLeadForPlaceThatAcceptsFees = (
      <button id="brief_position_request" className="btn btn-primary m-3" onClick={props.followLead} >{t('availableLead.positionMe')}</button>
  );

  const followedLeadForPlaceThatDoNoAcceptsFees = (
    <>
      <button id="brief_position_request" className="btn btn-primary m-3" onClick={followLeadAndDisplayEmail} >{t('availableLead.positionMe')} <sup>*</sup></button>
      <div><i>{t('availableLead.emailNote')}</i></div>
    </>
  );

  if (props.loggedInPlace.acceptReward) {
    return followedLeadForPlaceThatAcceptsFees;
  }
  else {
    return followedLeadForPlaceThatDoNoAcceptsFees;
  }


}

export default FollowLeadButton;
